export const CONTRACT_REQUEST = "CONTRACT_REQUEST";
export const CONTRACT_SUCCESS = "CONTRACT_SUCCESS";
export const CONTRACT_FAIL = "CONTRACT_FAIL";
